import { lazy, Suspense, useEffect, useState } from "react"

import type { MapReview } from "@/helpers/company/map-utils"
import type { CompanyLocation } from "@/types/models"

const CompanyMap = lazy(() =>
  import("@/components/company/company-map").then((mod) => ({
    default: mod.CompanyMap,
  }))
)

export function CompanyMapLazy({
  companyLocations,
  companySlug,
}: {
  companyLocations: CompanyLocation[]
  companySlug: string
}) {
  const [isClient, setIsClient] = useState(false)
  const [mapReviews, setMapReviews] = useState<MapReview[]>([])

  useEffect(() => setIsClient(true), [])

  useEffect(() => {
    const controller = new AbortController()

    fetch(`/api/company/${companySlug}/map-reviews`, {
      signal: controller.signal,
    })
      .then((res) => {
        if (res.ok) return res.json()
        throw new Error(`Failed to fetch map reviews: ${res.status}`)
      })
      .then((data) => setMapReviews(data))
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.error("Failed to load map reviews:", err)
        }
      })

    return () => controller.abort()
  }, [companySlug])

  if (!isClient) {
    return (
      <div className="bg-muted flex h-full w-full items-center justify-center">
        <p className="text-muted-foreground">Loading map...</p>
      </div>
    )
  }

  return (
    <Suspense
      fallback={
        <div className="bg-muted flex h-full w-full items-center justify-center">
          <p className="text-muted-foreground">Loading map...</p>
        </div>
      }
    >
      <CompanyMap companyLocations={companyLocations} mapReviews={mapReviews} />
    </Suspense>
  )
}
